/**
 * App Storage class
 * @description This will be responsible for storing data into the application.
 * Commonly, people use LocalStorage or SessionStorage. This is just a wrapper over them
 * because to restrict the usage of Global window storage throughtout the application
 * Default, this is just using the LocalStorage
 */
export class AppStorage {
  constructor(name, storage) {
    this.name = name;
    this.storage = storage;

    /** Is storage is supported or not */
    if (!this.isSupported()) {
      throw new Error('Storage is not supported by browser!');
    }
  }

  //-------------------------------------------------------

  setItem(key, value) {
    if (typeof value === Number)
      this.storage.setItem(key, value);
    else if (typeof value === String)
      this.storage.setItem(key, value);
    else
      this.storage.setItem(key, JSON.stringify(value));
  }
  
  getItem(key) {
    const value = this.storage.getItem(key)
    if (value && value.startsWith("\""))
      return JSON.parse(value);
    return value;
  }

  removeItem(key) {
    this.storage.removeItem(key);
  }

  clear(key) {
    this.storage.clear(key);
  }

  //-------------------------------------------------------

  setMapItem(key, value) {
    this.storage.setItem(key, JSON.stringify(Array.from(value.entries())));
  }

  getMapItem(key) {
    return new Map(JSON.parse(this.storage.getItem(key)));
  }
  //-------------------------------------------------------

  /**
   * @description Check for storage support
   * @returns {boolean} supported
   * */
  isSupported() {
    return !!this.storage;
  }

  toString() {
    return this.name;
  }

  getName() {
    return this.name;
  }
}

/**
 * Creating the instance of storage. Default will be localStorage
 * but if you want to create instance for session storage then pass window.sessionStorage as parameter
 */
const appLocalStorage = new AppStorage('local', window.localStorage);
const appSessionStorage = new AppStorage('session', window.sessionStorage);

const storage = new class {
  get(field, defaultValue) {
    const value = field.storage.getItem(field.key)
    if (typeof value === 'undefined' || value === null) {
        // console.log("get("+field.key+") => "+value+", returning default value "+defaultValue)
        return defaultValue
    }
    else {
        // console.log("get("+field.key+") => "+value)
    }
    if (field.type === 'int')
      return parseInt(value)
    else if (field.type === 'long')
      return parseInt(value)
    else
      return value
  }
  set(field, value) {
      field.storage.setItem(field.key, value)
  }
  clear(field) {
      // console.log("clear("+field.key+")")
      field.storage.removeItem(field.key)
  }
}

export { storage, appLocalStorage, appSessionStorage };
